
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { refreshTokenLink } from './refreshTokenLink'
import { retryLink } from './retryLink'
import { split } from 'apollo-link'
import { hasSubscription } from '@jumpn/utils-graphql'
import { initialTokenLink } from './initialTokenLink'
import { createtSocketLink } from './absintheSocketLink'
import env from '@polleverywhere/core/lib/env'
import EventEmitter from 'eventemitter3'

// Instantiate required constructor fields
const cache = new InMemoryCache({
  freezeResults: true
})
const httpLink = new HttpLink({
  uri: env.get('graphql_url').toString(),
  credentials: 'include'
})
const emitter = new EventEmitter()

const mainLink = retryLink.concat(initialTokenLink).concat(refreshTokenLink).concat(httpLink)
const subscriptionLink = createtSocketLink(env.get('api_server_url'), emitter)

const link = split(
  (operation) => hasSubscription(operation.query),
  subscriptionLink,
  mainLink
)

const client = new ApolloClient({
  // Provide required constructor fields
  cache: cache,
  link,

  // Provide some optional constructor fields
  name: 'core-web-client',
  version: '0.1',
  assumeImmutableResults: true,
  queryDeduplication: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    },
    watchQuery: {
      fetchPolicy: 'network-only'
    }
  }
})
client.on = emitter.on.bind(emitter)
client.off = emitter.off.bind(emitter)

export default client
